export const colors = {
  INK: '#05070B',
  NAVY: '#0B1F3A',
  NAVY_2: '#13305C',
  SKY: '#3DA9FC',
  DATA: '#1F6FD1',
  SUCCESS: '#1F9D63',
  SUCCESS_DOT: '#3DDC97',
  SUCCESS_TEXT: '#B9F2D6',
  PAGE: '#F4F6FA',
  CARD: '#FFFFFF',
  TEXT_2: '#4A5568',
  TEXT_BODY: '#2D3748',
  BORDER: '#C9D2E0',
  DIVIDER: '#E3E8F0',
  ROW_BORDER: '#EEF1F6',
  SOFT: '#EEF2F8',
  CODE_BG: '#F1F4F9',
  ROW_HOVER: '#F4F7FC',
  ROW_SELECTED: '#E4EEFB',
  INFO_BG: '#EAF4FE',
  ERROR_BG: '#FDECEC',
  ERROR_TEXT: '#8A1C1C',
  WARNING_BG: 'rgba(240,173,78,0.18)',
  WARNING_DOT: '#F0AD4E',
  WARNING_TEXT: '#FFE2B3',
};

export const cssVariables = `
  :root {
    --color-ink: ${colors.INK};
    --color-navy: ${colors.NAVY};
    --color-navy-2: ${colors.NAVY_2};
    --color-sky: ${colors.SKY};
    --color-data: ${colors.DATA};
    --color-success: ${colors.SUCCESS};
    --color-success-dot: ${colors.SUCCESS_DOT};
    --color-success-text: ${colors.SUCCESS_TEXT};
    --color-page: ${colors.PAGE};
    --color-card: ${colors.CARD};
    --color-text-2: ${colors.TEXT_2};
    --color-text-body: ${colors.TEXT_BODY};
    --color-border: ${colors.BORDER};
    --color-divider: ${colors.DIVIDER};
    --color-row-border: ${colors.ROW_BORDER};
    --color-soft: ${colors.SOFT};
    --color-code-bg: ${colors.CODE_BG};
    --color-row-hover: ${colors.ROW_HOVER};
    --color-row-selected: ${colors.ROW_SELECTED};
    --color-info-bg: ${colors.INFO_BG};
    --color-error-bg: ${colors.ERROR_BG};
    --color-error-text: ${colors.ERROR_TEXT};
    --color-warning-bg: ${colors.WARNING_BG};
    --color-warning-dot: ${colors.WARNING_DOT};
    --color-warning-text: ${colors.WARNING_TEXT};
  }
`;
